module.exports = __webpack_public_path__ + "static/media/scanner.ec3dafbb.png";